var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ad'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('inner-nav',{attrs:{"innerData":_vm.innerData,"innerTitle":_vm.innerTitle}}),_vm._v(" "),_c('div',{staticClass:"msg"},[_vm._v("\n      未能找到关于\""),_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v("\"的搜索结果\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83ca2bb8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/searchResult.vue
// module id = null
// module chunks = 